module.exports = __webpack_public_path__ + "img/btn_login.dc7f42f3.png";